import { RouteN } from 'routing/routes-path';

export const goToAlertList = () => {
    return RouteN.alerts.route;
};

export const goToAlertDetail = (id: string) => {
    return RouteN.alerts.route + '/' + RouteN.alerts.children.detail.replace(':id', id);
};
